import { render, staticRenderFns } from "./ClientCalls.vue?vue&type=template&id=477b07fa&"
import script from "./ClientCalls.vue?vue&type=script&lang=js&"
export * from "./ClientCalls.vue?vue&type=script&lang=js&"
import style0 from "./ClientCalls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports